/**
 * Collection Variant Sort
 *
 * This module sort variants in order on collection landing page.
 * Dependancy with variants array in sections/collection.liquid.
 */
require('custom/algolia-utils');
require('custom/utils'); // getDeviceSizeName

custom.variantSort = (() => {
  const initId = 'js-collection-variants';
  const columnsDesktop = {
    xsmall: 3,
    small: 3,
    medium: 4,
    large: 5,
    xlarge: 6,
  };

  /**
   * decodeHTMLEntities
   * @param {array} arr - Array of variant text with encoded
   * Returns array after decoding all HTML entities
   */
  function decodeHTMLEntities(arr = []) {
    const parser = new DOMParser();
    return arr.map(
      (val) => parser.parseFromString(val, 'text/html').body.textContent,
    );
  }

  /**
   * sortHandler
   * @param {array} arr - Array of variant text
   * Returns in-order variant array based on
   * custom.algoliaUtils.getSizeNum calculation
   */
  function sortHandler(arr = []) {
    return arr.sort((a, b) => {
      return (
        custom.algoliaUtils.getSizeNum(a) - custom.algoliaUtils.getSizeNum(b)
      );
    });
  }

  /**
   * getModifierClass
   * @param {array} arr - Array of variant text
   * Returns modifier class to be added to variant container
   * Loloi is figuring out the layout rules now,
   * so this modifier class is not being used at the moment.
   */
  function getModifierClass(arr = []) {
    switch (arr.length) {
      case 12:
      case 8:
        return 'fourths';
      case 9:
        return 'thirds';
      case 7:
        return 'fourths';
      default:
        return 'fourths';
    }
  }

  function render(variants = [], wrapperId = '') {
    variants = variants.filter((variant) => variant !== 'Default Title');
    const id = wrapperId !== '' ? wrapperId : initId;
    const variantContainer = document.getElementById(id);
    variantContainer.classList.add(getModifierClass(variants));

    let output = '';

    const deviceSize = custom.utils.getDeviceSizeName();
    const columnNum = columnsDesktop[deviceSize];

    variants.forEach((variant, index) => {
      if (index % columnNum === 0) {
        output += `<table><tr><td>${variant}</td>`;
      } else if (
        index % columnNum === columnNum - 1 ||
        index === variants.length - 1
      ) {
        output += `<td>${variant}</td></tr></table>`;
      } else {
        output += `<td>${variant}</td>`;
      }
    });
    variantContainer.innerHTML = output;
  }

  function init(variants = [], wrapperId = '') {
    if (!variants) return false;
    variants = sortHandler(decodeHTMLEntities(variants));
    render(variants, wrapperId);
    window.addEventListener(
      'resize',
      custom.utils.debounce(() => {
        render(variants, wrapperId);
      }, 100),
    );
  }

  return {
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/variant-sort.js